import http, { getAuthConfig } from './http';

import { CONSTANTS } from '@/utils';

const VOUCHER_BASE_URL = '/vouchers';
const PAYMENT_BASE_URL = '/payment';

const getVoucherCode = (voucherCode, callback) => {
  http
    .get(`${VOUCHER_BASE_URL}/${voucherCode}`, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: error.response?.data, error }));
};

const getBankAccounts = (callback) => {
  http
    .get(`${PAYMENT_BASE_URL}/bank_accounts`, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: error.response?.data, error }));
};

const submitPayment = (
  uuid,
  activeVoucher,
  productType,
  paymentMethod,
  itemData,
  quantity,
  subscribedUuid,
  SubscribedType,
  userName,
  userPhone,
  userEmail,
  idempotencyKey,
  callback,
  fbp,
  fbc,
  utmParams = null
) => {
  const data = {
    item_type: productType.value,
    purchasable_type: productType.id,
    method: paymentMethod,
    item_uuid: uuid,
    purchasable_uuid: uuid,
    item_quantity: quantity,
    subscribed_uuid: subscribedUuid,
    subscribed_type: SubscribedType,
    name: userName,
    email: userEmail,
    phone: userPhone,
    idempotency_key: idempotencyKey,
  };

  if (activeVoucher) data.voucher_code = activeVoucher;
  if (productType.value === CONSTANTS.PRODUCT_TYPE.EVENT.value) data.item_data = JSON.stringify(itemData);

  if (fbp) data.fbp = fbp;
  if (fbc) data.fbc = fbc;

  // Add UTM parameters to server payload
  if (utmParams) {
    if (utmParams.utm_source) data.utm_source = utmParams.utm_source;
    if (utmParams.utm_medium) data.utm_medium = utmParams.utm_medium;
    if (utmParams.utm_campaign) data.utm_campaign = utmParams.utm_campaign;
    if (utmParams.utm_content) data.utm_content = utmParams.utm_content;
    if (utmParams.fbclid) data.fbclid = utmParams.fbclid;
  }

  if (utmParams) {
    if (utmParams.utm_source) data.utm_source = utmParams.utm_source;
    if (utmParams.utm_medium) data.utm_medium = utmParams.utm_medium;
    if (utmParams.utm_campaign) data.utm_campaign = utmParams.utm_campaign;
    if (utmParams.utm_content) data.utm_content = utmParams.utm_content;
    if (utmParams.fbclid) data.fbclid = utmParams.fbclid;
  }

  http
    .post(`${PAYMENT_BASE_URL}`, data, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: error.response?.data || 'Transaksi Gagal', error }));
};

const confirmTransfer = (invoiceNumber, formData, callback) => {
  http
    .post(`${PAYMENT_BASE_URL}/${invoiceNumber}/confirm`, formData, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: null, error }));
};

const cancelPayment = (invoiceNumber, callback) => {
  http
    .post(`${PAYMENT_BASE_URL}/${invoiceNumber}/cancel`, null, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: null, error }));
};

const statusPayment = (invoiceNumber, callback) => {
  http
    .post(`${PAYMENT_BASE_URL}/${invoiceNumber}/status`, null, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: null, error }));
};

const enrollCourse = (uuid, callback) => {
  http
    .post(`${PAYMENT_BASE_URL}/${uuid}/enroll`, null, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: null, error }));
};

const submitBulkPayment = (
  cartItems,
  voucherCode,
  paymentMethod,
  guestDetails,
  idempotencyKey,
  callback,
  fbp,
  fbc,
  utmParams = null
) => {
  const data = {
    method: paymentMethod,
    idempotency_key: idempotencyKey,
    cart_items: cartItems.map((item) => {
      const itemUuid = item.id || item.uuid;
      const itemPayload = {
        item_uuid: itemUuid,
        purchasable_uuid: itemUuid,
        item_type: item.itemType,
        quantity: item.quantity || 1,
      };

      let pTypeId;
      for (const key in CONSTANTS.PRODUCT_TYPE) {
        if (CONSTANTS.PRODUCT_TYPE[key].value === item.itemType) {
          pTypeId = CONSTANTS.PRODUCT_TYPE[key].id;
          break;
        }
      }
      if (pTypeId !== undefined) {
        itemPayload.purchasable_type = pTypeId;
      }

      if (item.itemType === CONSTANTS.PRODUCT_TYPE.EVENT.value && item.itemData) {
        itemPayload.item_data = JSON.stringify(item.itemData);
      }

      return itemPayload;
    }),
  };

  if (voucherCode) data.voucher_code = voucherCode;
  if (fbp) data.fbp = fbp;
  if (fbc) data.fbc = fbc;

  // Add UTM parameters to server payload
  if (utmParams) {
    if (utmParams.utm_source) data.utm_source = utmParams.utm_source;
    if (utmParams.utm_medium) data.utm_medium = utmParams.utm_medium;
    if (utmParams.utm_campaign) data.utm_campaign = utmParams.utm_campaign;
    if (utmParams.utm_content) data.utm_content = utmParams.utm_content;
    if (utmParams.fbclid) data.fbclid = utmParams.fbclid;
  }

  if (guestDetails) {
    data.name = guestDetails.name;
    data.email = guestDetails.email;
    data.phone = guestDetails.phone;
  }

  http
    .post(`${PAYMENT_BASE_URL}`, data, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: error.response?.data || 'Bulk Transaction Failed', error }));
};

export const SERVICE_PAYMENT = {
  getVoucherCode,
  submitPayment,
  submitBulkPayment,
  getBankAccounts,
  confirmTransfer,
  cancelPayment,
  statusPayment,
  enrollCourse,
};
